"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _Input = _interopRequireDefault(require("elevate-ui/Input"));

var _NumberIncrement = _interopRequireDefault(require("elevate-ui/NumberIncrement"));

var _Select = _interopRequireDefault(require("elevate-ui/Select"));

var _Padding = _interopRequireDefault(require("../../Common/Padding"));

var _Uploader = _interopRequireDefault(require("../../Common/Uploader"));

var _Alignment = _interopRequireDefault(require("../../Common/Alignment"));

var _ColorPicker = _interopRequireDefault(require("elevate-ui/ColorPicker"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RowForm = function RowForm(props) {
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "backgroundColor",
    name: "backgroundColor",
    label: "Background Color",
    colorMode: "hex",
    component: _ColorPicker["default"]
  }), /*#__PURE__*/_react["default"].createElement(_Padding["default"], null), /*#__PURE__*/_react["default"].createElement(_Alignment["default"], null), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "width",
    name: "width",
    label: "Width",
    component: _Input["default"],
    type: "text"
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "height",
    name: "height",
    label: "Height",
    component: _Input["default"],
    type: "text"
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "borderSize",
    name: "borderSize",
    label: "Border Size",
    component: _NumberIncrement["default"],
    min: "0"
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "borderColor",
    name: "borderColor",
    label: "Border Color",
    colorMode: "hex",
    component: _ColorPicker["default"]
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "backgroundImage",
    name: "backgroundImage",
    label: "Background Image (optional)",
    component: _Input["default"],
    type: "text"
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "upload",
    name: "upload",
    label: "Upload a file",
    component: _Uploader["default"],
    UPLOADCARE_API_KEY: props.UPLOADCARE_API_KEY,
    type: "hidden",
    fieldName: "backgroundImage"
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "backgroundSize",
    name: "backgroundSize",
    label: "Background Size",
    component: _Select["default"],
    items: [{
      label: "Cover",
      value: "cover"
    }, {
      label: "Contain",
      value: "contain"
    }]
  }));
};

var _default = RowForm;
exports["default"] = _default;